<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
    <mat-card-header>
        @if(isProcessing){
            <div style="margin-bottom:30px;width:100%;">
                <app-processing-banner [WaitMessage]="processingMessage" style="width:100%"></app-processing-banner>
            </div>
        }
    </mat-card-header>    

    <mat-card-content>
        <span style="margin-left: 0px;margin-top:20px;"  class="ace-heading-text-level-2">Configure PARCS Settings</span>
        
        @if(selectedPARCS !== '' || undefined){
            <br /><br /><span class="ace-heading-text-level-2">Selected PARCS: {{selectedPARCS}}</span> 
        }  
        <mat-stepper linear="true" #stepper>
            <mat-step [stepControl]="parcsEntryForm" label="Enter Amano One Facility Id" [editable]="isActivationInProgress">
                <form [formGroup]="parcsEntryForm">
                    <div class="row">
                    <div class="col-6">
                            <mat-form-field style="width:98%;">
                                <mat-label>Facility Id</mat-label>
                                <input matInput formControlName="facilityId" placeholder="@@@@@@@@-@@@@-@@@@-@@@@-@@@@@@@@@@@@"
                                    required>
                                <mat-error>The Facility Id is rquired</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <div style="margin-top:30px;">

                            @if(faclityIdError){
                                <span style="color:red;"><strong>This Facility Id cannot be located.  Please try again.</strong></span>
                            } @else {
                                <span>Enter the Facility Id to validate.</span>
                            }
                            
                            </div>
                        </div>
                    </div>
                <div style="margin-top:10px;">
                    <button mat-raised-button color="primary" (click)="onParcsStepOne()">Next</button>
                </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="parcsEntryForm" label="Select Amano ONE LPR Status" [editable]="isActivationInProgress">
                <form [formGroup]="parcsEntryForm">
                    <div class="row">
                        <div class="col-6">
                            <div style="margin-top:30px;">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" formControlName="lprIsPrimary">
                            <mat-button-toggle value="lprDisabled">LPR Disabled</mat-button-toggle>  
                            <mat-button-toggle value="lprEnabled">LPR Enabled</mat-button-toggle>
                            </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                <div style="margin-top:10px;">
                    <button mat-raised-button color="primary" matStepperPrevious>Back</button>
                    <button mat-raised-button color="primary" matStepperNext (click)="onParcsStepTwo()">Next</button>
                </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="parcsReviewForm" label="Review PARCS Settings" [editable]="isActivationInProgress">
                <form [formGroup]="parcsReviewForm">
                    <div class="row">
                    <div class="col-4">
                            <mat-form-field style="width:98%;" appearance="outline">
                                <mat-label>Facility Id</mat-label>
                                <input matInput formControlName="facilityId" placeholder="" readonly="true">
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field style="width:98%;" appearance="outline">
                                <mat-label>Facility Name</mat-label>
                                <input matInput formControlName="facilityName" placeholder="" readonly="true">
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <div style="margin-top:30px;">
                            <div style="margin-top:20px'">
                                <span>LPR Enabled Status: {{lprStatusText}}</span>
                            </div>
                            </div>
                        </div>
                    </div>
                <div>
                    <button mat-raised-button color="primary" matStepperPrevious>Back</button>
                    <button mat-raised-button color="primary" (click)="onSubmitAmanoOneFacility()">Submit and Activate</button>
                </div>
                </form>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Amano One Successfully Configured!</ng-template>
                <p style="font-size:18px;font-weight:bold;">Flash has been successfully activated and configured.</p>
                <p style="font-size:18px;">Lot {{_appGeneralState.currentLotNumber}} Amano One has been activated on Facility <strong>{{_selectedParcsName}}</strong></p>
                <p style="font-size:18px;">LPR Enabled Status: <strong>{{lprStatusText}}</strong> </p>
                <div>
                </div>
            </mat-step>
        </mat-stepper>
   
    </mat-card-content>
</mat-card>





 <!-- @if (isValidationState) {
        <p>Step 1.  Enter Data below and check that the configuration is valid</p>

        <form 
        (ngSubmit)="onSubmitReviewAmanoData()" 
        novalidate
        [formGroup]="amanoForm" 
        style="margin-top:20px;">
        <div class="row row-gap-0">
            <div class="col-5">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label >Enter Facility Id</mat-label>
                    <input matInput placeholder="Facility Id" value="" formControlName="facilityId">
                </mat-form-field>
            </div>
            <div class="col-5">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label >Enter Entity Id</mat-label>
                    <input matInput placeholder="Entity Id" value="" formControlName="entityId">
                </mat-form-field>
            </div>
            <div class="col-2">
                <div style="margin-top:10px;">
                <mat-checkbox formControlName="lprIsPrimary">
                    Enable LPR?
                </mat-checkbox>
                </div>
            </div>
            <div class="row">
            <div class="col-6">
                <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!amanoForm.valid">Validate</button>
                <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="resetAmanoForm()">Clear</button>
            </div>
            </div>
        </div>
        </form>
    }
    @else{
         <p>Step 2.  Enter Data below and check that the configuration is valid</p>

        <form 
        (ngSubmit)="onSubmitAmanoData()" 
        novalidate
        [formGroup]="amanoEditForm" 
        style="margin-top:20px;">
        <div class="row row-gap-0">
            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label >Review Facility Id</mat-label>
                    <input matInput placeholder="Facility Id" value="" formControlName="facilityId" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label >Review Facility Name</mat-label>
                    <input matInput placeholder="Facility Id" value="" formControlName="facilityId" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label >Review Entity Id</mat-label>
                    <input matInput placeholder="Entity Id" value="" formControlName="entityId" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-2">
                <div style="margin-top:10px;">
                <mat-checkbox formControlName="lprIsPrimary" readonly="true">
                    Enable LPR?
                </mat-checkbox>
                </div>
            </div>
            <div class="row">
            <div class="col-6">
                <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" >Submit</button>
                <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onCancelSubmitValus()">Cancel</button>
            </div>
            </div>
        </div>
        </form>
    } -->
